import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class ValuationApproachExclusionReason {
		constructor(doc)
		{
		this.label = null;
		this.valuationApproachExclusionReasonType = null;
		this.valuationApproachExclusionReasonTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.valuationApproachExclusionReasonType = x.getStringElement(doc, "./ns:ValuationApproachExclusionReasonType");
		this.valuationApproachExclusionReasonTypeOtherDescription = x.getStringElement(doc, "./ns:ValuationApproachExclusionReasonTypeOtherDescription");
	 }

	GetExclusionReasonType() {
		return h.descriptionOrOther(this.valuationApproachExclusionReasonType, this.valuationApproachExclusionReasonTypeOtherDescription);
	}
	 
}

